<div *ngIf="auction$ | async as auction" class="module-container-full-width gb-page-not-found">
  <div class="mascot-container">
    <gb-mascot></gb-mascot>
  </div>

  <div class="message-block flex-row-center">
    <div>
      <h1 [translate]="errorMessage"></h1>
    </div>
  </div>

  <div class="btn-container flex-row-center">
    <button
      type="button"
      mat-raised-button
      color="primary"
      class="full-width-button-xs"
      (click)="auction.item_count ? goToItems() : goToHomepage()"
    >
      <span
        [translate]="auction.item_count ? 'PAGE_NOT_FOUND.GO_TO_ALL_ITEMS' : 'PAGE_NOT_FOUND.GO_TO_HOMEPAGE'"
      ></span>
    </button>
  </div>
</div>
